import EditorSwitch, { getSwitchValues } from '../../editorInputs/EditorSwitch';
import EditorInput, { getInputValues, getInputNumberValues } from '../../editorInputs/EditorInput';
import EditorDropDown, { getDropDownValues } from '../../editorInputs/EditorDropDown';
import EditorTextarea from '../../editorInputs/EditorTextarea';
import EditorSlider from '../../editorInputs/EditorSlider';

export default {
	marginTop: {
		title: 'Margem Superior',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	marginBottom: {
		title: 'Margem Inferior',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	marginLeft: {
		title: 'Margem Esquerda',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	marginRight: {
		title: 'Margem Direita',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	paddingTop: {
		title: 'Espaçamento Superior',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	paddingBottom: {
		title: 'Espaçamento Inferior',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	paddingLeft: {
		title: 'Espaçamento Esquerdo',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	paddingRight: {
		title: 'Espaçamento Direito',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	colGap: {
		title: 'colGap',
		type: EditorSlider,
		getValues: getSliderValues,
	},
	fullWidth: {
		title: 'Largura total',
		tooltip: 'Define se o componente deve ocupar todo o espaço disponível de seu elemento parente',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	borderWidth: {
		title: 'Largura da borda',
		type: EditorSlider,
		getValues: getBorderWidthValues,
	},
	preload: {
		title: 'Pré-carregamento',
		tooltip: 'Pré-carrega a primeira imagem, ajudando a priorizar o display de imagens.',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	label: {
		title: 'Label',
		type: EditorInput,
		getValues: getInputValues,
	},
	inputLabel: {
		title: 'Label',
		type: EditorInput,
		getValues: getInputValues,
	},
	errorMessage: {
		title: 'Mensagem de erro',
		type: EditorInput,
		getValues: getInputValues,
	},
	scroll: {
		title: 'Scroll',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	disableEscapeKeyDown: {
		title: 'Desabilitar Esc',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	fullScreen: {
		title: 'Tela Cheia',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	backdrop: {
		title: 'Backdrop Overlay',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	'OverlayLayout/backdrop': {
		title: 'Backdrop',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	customPixelEventId: {
		title: 'Custom Pixel Event Id',
		type: EditorInput,
		getValues: getInputValues,
	},
	customPixelEventName: {
		title: 'Custom Pixel Event Name',
		type: EditorInput,
		getValues: getInputValues,
	},
	trigger: {
		title: 'Modal Trigger',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	'OverlayTrigger/trigger': {
		title: 'Trigger',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	showCloseButton: {
		title: 'Mostrar botão de fechar',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showArrow: {
		title: 'showArrow',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	iconCloseSize: {
		title: 'Tamanho botão de fechar',
		type: EditorInput,
		getValues: getInputValues,
	},
	maxVisible: {
		title: 'MaxVisible',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	image: {
		title: 'Desktop Image',
		type: EditorInput,
		getValues: getInputValues,
	},
	mobileImage: {
		title: 'Mobile Image',
		type: EditorInput,
		getValues: getInputValues,
	},
	description: {
		title: 'Description',
		type: EditorInput,
		getValues: getInputValues,
	},
	optionsTitle: {
		title: 'optionsTitle',
		type: EditorInput,
		getValues: getInputValues,
	},
	emailAndPasswordTitle: {
		title: 'emailAndPasswordTitle',
		type: EditorInput,
		getValues: getInputValues,
	},
	accessCodeTitle: {
		title: 'accessCodeTitle',
		type: EditorInput,
		getValues: getInputValues,
	},
	emailPlaceholder: {
		title: 'emailPlaceholder',
		type: EditorInput,
		getValues: getInputValues,
	},
	passwordPlaceholder: {
		title: 'passwordPlaceholder',
		type: EditorInput,
		getValues: getInputValues,
	},
	accessCodePlaceholder: {
		title: 'accessCodePlaceholder',
		type: EditorInput,
		getValues: getInputValues,
	},
	iconLabel: {
		title: 'iconLabel',
		type: EditorInput,
		getValues: getInputValues,
	},
	providerPasswordButtonLabel: {
		title: 'providerPasswordButtonLabel',
		type: EditorInput,
		getValues: getInputValues,
	},
	identifierPlaceholder: {
		title: 'identifierPlaceholder',
		type: EditorInput,
		getValues: getInputValues,
	},
	invalidIdentifierError: {
		title: 'invalidIdentifierError',
		type: EditorInput,
		getValues: getInputValues,
	},
	termsAndConditions: {
		title: 'termsAndConditions',
		type: EditorInput,
		getValues: getInputValues,
	},
	forgotPassword: {
		title: 'forgotPassword',
		type: EditorInput,
		getValues: getInputValues,
	},
	dontHaveAccount: {
		title: 'dontHaveAccount',
		type: EditorInput,
		getValues: getInputValues,
	},
	placeholderText: {
		title: 'placeholderText',
		type: EditorInput,
		getValues: getInputValues,
	},
	url: {
		title: 'url',
		type: EditorInput,
		getValues: getInputValues,
	},
	// 'href': {
	//     'title': 'href',
	//     'type': EditorInput,
	//     'getValues': getInputValues
	// },

	mobileHeight: {
		title: 'Altura Mobile',
		tooltip: 'Altura em px do objeto no mobile (Opcional)',
		type: EditorInput,
		getValues: getInputValues,
	},
	mobileWidth: {
		title: 'Largura Mobile',
		tooltip: 'Largura em px do objeto no mobile (Opcional)',
		type: EditorInput,
		getValues: getInputValues,
	},
	colSizing: {
		title: 'ColSizing',
		tooltip: '',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	preserveLayoutOnMobile: {
		title: 'preserveLayoutOnMobile',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	horizontalAlign: {
		title: 'horizontalAlign',
		tooltip: '',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	'FlexLayoutCol/horizontalAlign': {
		title: 'horizontalAlign',
		tooltip: '',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	displayThreshold: {
		title: 'displayThreshold',
		type: EditorInput,
		getValues: getInputValues,
	},
	display: {
		title: 'display',
		tooltip: '',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	// 'categoryId':{
	//     'title':'categoryId',
	//     'type':EditorInput,
	//     'getValues':getInputNumberValues
	// },
	mzSearchDummyTitle: {
		title: 'Título de exibição',
		type: EditorInput,
		getValues: getInputValues,
	},
	skidding: {
		title: 'skidding',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	distance: {
		title: 'distance',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	text: {
		title: 'text',
		type: EditorTextarea,
		getValues: getInputValues,
	},
	preventHorizontalStretch: {
		title: 'preventHorizontalStretch',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	// 'tagTitle':{
	//     'title':'tagTitle',
	//     'type':EditorInput,
	//     'getValues':getInputValues
	// },
	'MenuItem/type': {
		title: 'type',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	highlight: {
		title: 'highlight',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	iconPosition: {
		title: 'iconPosition',
		type: EditorInput,
		getValues: getInputValues,
	},
	id: {
		title: 'id',
		type: EditorInput,
		getValues: getInputValues,
	},
	onMountBehavior: {
		title: 'onMountBehavior',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	isFullModeStyle: {
		title: 'Tamanho cheio',
		tooltip: 'Determina se o componente irá ocupar a largura total da tela',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	textPosition: {
		title: 'Posição do texto',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	imageUrl: {
		title: 'URL da imagem',
		type: EditorInput,
		getValues: getInputValues,
	},
	headline: {
		title: 'Título',
		type: EditorInput,
		getValues: getInputValues,
	},
	subhead: {
		title: 'Subtítulo',
		type: EditorTextarea,
		getValues: getInputValues,
	},
	callToActionText: {
		title: 'Texto do CTA',
		type: EditorInput,
		getValues: getInputValues,
	},
	callToActionUrl: {
		title: 'URL do CTA',
		type: EditorInput,
		getValues: getInputValues,
	},
	callToActionMode: {
		title: 'Tipo de CTA',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	attemptPageTypeSearch: {
		title: 'attemptPageTypeSearch',
		tooltip: 'Se ativo, ao clicar em um resultado que é uma categoria, departamento ou marca ',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	autocompleteAlignment: {
		title: 'Alinhamento Autocomplete',
		tooltip: 'Alinhamento do resultado do autocomplete',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	autocompleteFullWidth: {
		title: 'Autocomplete c/ largura total',
		tooltip: 'Representa se o autocomplete deve ocupar a largura total da janela',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	autoFocus: {
		title: 'autoFocus',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	blurOnSubmit: {
		title: 'blurOnSubmit',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	compactMode: {
		title: 'Modo compacto',
		tooltip: 'Define se será usado o modo compacto do componente',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	customSearchPageUrl: {
		title: 'URL de busca custom',
		tooltip: 'Template para URL custom. Pode-se usar "${term}" como placeholder para interpolar na URL de busca',
		placeholder: 'ex: /search?query=${term}',
		type: EditorInput,
		getValues: getInputValues,
	},
	displayMode: {
		title: 'Modo de exibição',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	'Link/displayMode': {
		title: 'Modo de exibição',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	'ProductImages/displayMode': {
		title: 'Modo de exibição',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	emptyPlaceholder: {
		title: 'Placeholder de busca vazia',
		tooltip: 'Placeholder a ser mostrado quando a busca não retorna resultados',
		type: EditorInput,
		getValues: getInputValues,
	},
	hasIconLeft: {
		title: 'Icone à esquerda',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	openAutocompleteOnFocus: {
		title: 'Abrir autocomplete ao focar',
		tooltip: 'Define se o autocomplete deve abrir ao usuário focar no input',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	placeholder: {
		title: 'Placeholder',
		type: EditorInput,
		getValues: getInputValues,
	},
	inputType: {
		title: 'Type do input',
		tooltip:
			'Define o "type" do element HTML. O valor "search" é recomendado pois soluciona alguns problemas em sistemas iOS',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	disableBlurAndTouchEndHandler: {
		title: 'disableBlurAndTouchEndHandler',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	variation: {
		title: 'variation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	drawerSlideDirection: {
		title: 'drawerSlideDirection',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	linkVariationUrl: {
		title: 'linkVariationUrl',
		type: EditorInput,
		getValues: getInputValues,
	},
	maxDrawerWidth: {
		title: 'maxDrawerWidth',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	openOnHover: {
		title: 'openOnHover',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	quantityDisplay: {
		title: 'quantityDisplay',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	itemCountMode: {
		title: 'itemCountMode',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	backdropMode: {
		title: 'backdropMode',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	MinicartIcon: {
		title: 'MinicartIcon',
		type: EditorInput,
		getValues: getInputValues,
	},
	orientation: {
		title: 'orientation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	onClickBehavior: {
		title: 'onClickBehavior',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	onClickEventPropagation: {
		title: 'onClickEventPropagation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	isOneClickBuy: {
		title: 'isOneClickBuy',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	customOneClickBuyLink: {
		title: 'customOneClickBuyLink',
		type: EditorInput,
		getValues: getInputValues,
	},
	unavailableText: {
		title: 'unavailableText',
		type: EditorInput,
		getValues: getInputValues,
	},
	customToastUrl: {
		title: 'customToastUrl',
		type: EditorInput,
		getValues: getInputValues,
	},
	showOnMobile: {
		title: 'showOnMobile',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	homeIconSize: {
		title: 'homeIconSize',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	caretIconSize: {
		title: 'caretIconSize',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	toastURL: {
		title: 'toastURL',
		type: EditorInput,
		getValues: getInputValues,
	},
	warningQuantityThreshold: {
		title: 'warningQuantityThreshold',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	showUnit: {
		title: 'showUnit',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showLabel: {
		title: 'showLabel',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	selectorType: {
		title: 'selectorType',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	quantitySelectorStep: {
		title: 'quantitySelectorStep',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	textAlignment: {
		title: 'textAlignment',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	src: {
		title: 'src',
		tooltip: 'Url da imagem',
		type: EditorInput,
		getValues: getInputValues,
	},
	alt: {
		title: 'alt',
		tooltip: 'Texto alternativo para a imagem',
		type: EditorInput,
		getValues: getInputValues,
	},
	maxWidth: {
		title: 'maxWidth',
		type: EditorInput,
		getValues: getInputValues,
	},
	minHeight: {
		title: 'minHeight',
		type: EditorInput,
		getValues: getInputValues,
	},
	minWidth: {
		title: 'minWidth',
		type: EditorInput,
		getValues: getInputValues,
	},
	mzGiftImage: {
		title: 'mzGiftImage',
		type: EditorInput,
		getValues: getInputValues,
	},
	srcset: {
		title: 'srcset',
		type: EditorInput,
		getValues: getInputValues,
	},
	sizes: {
		title: 'sizes',
		type: EditorInput,
		getValues: getInputValues,
	},
	link: {
		title: 'Link',
		type: EditorInput,
		getValues: getInputValues,
	},
	collapseContent: {
		title: 'collapseContent',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	title: {
		title: 'Título',
		type: EditorInput,
		getValues: getInputValues,
	},
	showTitle: {
		title: 'showTitle',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	aspectRatio: {
		title: 'aspectRatio',
		type: EditorInput,
		getValues: getInputValues,
	},
	contentOrder: {
		title: 'contentOrder',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	displayThumbnailsArrows: {
		title: 'displayThumbnailsArrows',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	hiddenImages: {
		title: 'hiddenImages',
		type: EditorInput,
		getValues: getInputValues,
	},
	position: {
		title: 'position',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	thumbnailVisiblity: {
		title: 'thumbnailVisiblity',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	thumbnailAspectRatio: {
		title: 'thumbnailAspectRatio',
		type: EditorInput,
		getValues: getInputValues,
	},
	thumbnailMaxHeight: {
		title: 'thumbnailMaxHeight',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	thumbnailsOrientation: {
		title: 'thumbnailsOrientation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	zoomFactor: {
		title: 'zoomFactor',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	zoomMode: {
		title: 'zoomMode',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	ModalZoom: {
		title: 'ModalZoom',
		type: EditorInput,
		getValues: getInputValues,
	},
	contentType: {
		title: 'contentType',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	isFullWidth: {
		title: 'isFullWidth',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	slideDirection: {
		title: 'slideDirection',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	renderinrStrategy: {
		title: 'renderinrStrategy',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	submitButtonLabel: {
		title: 'submitButtonLabel',
		type: EditorInput,
		getValues: getInputValues,
	},
	criteria: {
		title: 'criteria',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	labelMatchCriteria: {
		title: 'labelMatchCriteria',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	index: {
		title: 'index',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	showBadge: {
		title: 'showBadge',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	badgeText: {
		title: 'badgeText',
		type: EditorInput,
		getValues: getInputValues,
	},
	showCollections: {
		title: 'showCollections',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	mainImageLabel: {
		title: 'mainImageLabel',
		type: EditorInput,
		getValues: getInputValues,
	},
	width: {
		title: 'width',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	height: {
		title: 'height',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	maxHeight: {
		title: 'maxHeight',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	tag: {
		title: 'tag',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	showProductReference: {
		title: 'showProductReference',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showSku: {
		title: 'showSku',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showBrandName: {
		title: 'showBrandName',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	value: {
		title: 'value',
		type: EditorInput,
		getValues: getInputValues,
	},
	category: {
		title: 'category',
		type: EditorInput,
		getValues: getInputValues,
	},
	collection: {
		title: 'collection',
		type: EditorInput,
		getValues: getInputValues,
	},
	orderBy: {
		title: 'orderBy',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	hideUnavailableItems: {
		title: 'hideUnavailableItems',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	maxItems: {
		title: 'maxItems',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	skuFilter: {
		title: 'skuFilter',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	installmentCriteria: {
		title: 'installmentCriteria',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	listName: {
		title: 'listName',
		type: EditorInput,
		getValues: getInputValues,
	},
	preferredSKU: {
		title: 'preferredSKU',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	recommendation: {
		title: 'recommendation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	titleText: {
		title: 'titleText',
		type: EditorInput,
		getValues: getInputValues,
	},
	itemsPerPage: {
		title: 'itemsPerPage',
		type: EditorInput,
		getValues: getInputNumberValues,
	},

	showNavigationArrows: {
		title: 'showNavigationArrows',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	showPaginationDots: {
		title: 'showPaginationDots',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	infinite: {
		title: 'infinite',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	usePagination: {
		title: 'usePagination',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	navigationStep: {
		title: 'navigationStep',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	centerMode: {
		title: 'centerMode',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	centerModeSlidesGap: {
		title: 'centerModeSlidesGap',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	timeout: {
		title: 'timeout',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	stopOnHover: {
		title: 'stopOnHover',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	speed: {
		title: 'speed',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	delay: {
		title: 'delay',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	timing: {
		title: 'timing',
		type: EditorInput,
		getValues: getInputValues,
	},
	desktop: {
		title: 'desktop',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	tablet: {
		title: 'tablet',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	phone: {
		title: 'phone',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	mobile: {
		title: 'mobile',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	shareLabelClass: {
		title: 'shareLabelClass',
		type: EditorInput,
		getValues: getInputValues,
	},
	buttonContainerClass: {
		title: 'buttonContainerClass',
		type: EditorInput,
		getValues: getInputValues,
	},
	Facebook: {
		title: 'Facebook',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	Twitter: {
		title: 'Twitter',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	WhatsApp: {
		title: 'WhatsApp',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	Pinterest: {
		title: 'Pinterest',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	size: {
		title: 'size',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	hideImpossibleCombinations: {
		title: 'hideImpossibleCombinations',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	imageHeight: {
		title: 'imageHeight',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	imageWidth: {
		title: 'imageWidth',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	initialSelection: {
		title: 'initialSelection',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	showValueForVariation: {
		title: 'showValueForVariation',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	sliderArrowSize: {
		title: 'sliderArrowSize',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	sliderDisplayTreshold: {
		title: 'sliderDisplayTreshold',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	showVariationsErrorMessage: {
		title: 'showVariationsErrorMessage',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showVariationsLabels: {
		title: 'showVariationsLabels',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	variationsSpacing: {
		title: 'variationsSpacing',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	thumbnailImage: {
		title: 'thumbnailImage',
		type: EditorInput,
		getValues: getInputValues,
	},
	visibility: {
		title: 'visibility',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	visibleVariations: {
		title: 'visibleVariations',
		type: EditorInput,
		getValues: getInputValues,
	},
	paymentMethods: {
		title: 'paymentMethods',
		type: EditorInput,
		getValues: getInputValues,
	},
	showInColor: {
		title: 'showInColor',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	checkboxLabel: {
		title: 'checkboxLabel',
		type: EditorInput,
		getValues: getInputValues,
	},
	markers: {
		title: 'Markers',
		type: EditorInput,
		getValues: getInputValues,
	},
	message: {
		title: 'Mensagem',
		tooltip: 'Define o texto padrão a ser renderizado na UI',
		type: EditorTextarea,
		getValues: getInputValues,
	},
	installmentsCriteria: {
		title: 'installmentsCriteria',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	paymentSystemName: {
		title: 'paymentSystemName',
		type: EditorInput,
		getValues: getInputValues,
	},
	installmentsQuantity: {
		title: 'installmentsQuantity',
		type: EditorInput,
		getValues: getInputNumberValues,
	},
	alwaysShow: {
		title: 'Sempre Mostrar',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	visible: {
		title: 'Visível',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	name: {
		title: 'Nome do vídeo',
		type: EditorInput,
		getValues: getInputValues,
	},
	'Gallery/name': {
		title: 'Nome do grid',
		type: EditorInput,
		getValues: getInputValues,
	},
	poster: {
		title: 'Cover image',
		type: EditorInput,
		getValues: getInputValues,
	},
	controlsType: {
		title: 'controlsType',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},
	autoPlay: {
		title: 'autoPlay',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	muted: {
		title: 'Inicia sem som',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	loop: {
		title: 'Loop',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	playsInline: {
		title: 'playsInline',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	'Video/type': {
		title: 'Type',
		type: EditorInput,
		getValues: getInputValues,
	},
	mzShowThen: {
		title: 'Mostrar Condição Satisfeita',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	pointer: {
		title: 'pointer',
		type: EditorInput,
		getValues: getInputValues,
	},
	showCurrentProduct: {
		title: 'showCurrentProduct',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showSelectableBoxes: {
		title: 'showSelectableBoxes',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showButtonIcon: {
		title: 'showButtonIcon',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showListPrice: {
		title: 'showListPrice',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showSellingPrice: {
		title: 'showSellingPrice',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showInstallments: {
		title: 'showInstallments',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showTotalPrice: {
		title: 'showTotalPrice',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},
	showNumberOfItems: {
		title: 'showNumberOfItems',
		type: EditorSwitch,
		getValues: getSwitchValues,
	},

	subtitle: {
		title: 'subtitle',
		type: EditorInput,
		getValues: getInputValues,
	},
	buttonText: {
		title: 'buttonText',
		type: EditorInput,
		getValues: getInputValues,
	},

	verticalAlign: {
		title: 'verticalAlign',
		type: EditorDropDown,
		getValues: getDropDownValues,
	},

	mzImage: {
		title: 'imagem',
		type: EditorInput,
		getValues: getInputValues,
	},
	mzProductName: {
		title: 'Nome do produto',
		type: EditorInput,
		getValues: getInputValues,
	},
	mzSpecificationText: {
		title: 'Texto da especificação',
		type: EditorInput,
		getValues: getInputValues,
	},
};

function getSliderValues({ propValue, maxSize = 11, step = 1, minSize = 0 }: any) {
	return [{ propValue, maxSize, step, minSize }];
}

function getBorderWidthValues({ propValue, maxSize = 5 }: any) {
	return getSliderValues({ propValue, maxSize });
}
